import { render, staticRenderFns } from "./budgetSheet.vue?vue&type=template&id=60a87dfa&scoped=true"
import script from "./budgetSheet.vue?vue&type=script&lang=js"
export * from "./budgetSheet.vue?vue&type=script&lang=js"
import style0 from "./budgetSheet.vue?vue&type=style&index=0&id=60a87dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a87dfa",
  null
  
)

export default component.exports